import {takeLatestF, putAll, showSuccess, extractFormErrorsFromResponse} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {roleFormName} from '../../types';
import {buildRoleValuesForApi, getRoleFormValues} from '../../utils/role';
import {adminAction, UpdateRoleAction} from '../action';

const te = t('admin');

function* execute({payload: {roleId}}: UpdateRoleAction): SagaIterator {
    const roleFormValues = yield* select(getRoleFormValues);
    yield* put(formHelpers.startSubmit(roleFormName));

    const response = yield* call(
        Api.updateRole,
        buildRoleValuesForApi(roleFormValues),
        {roleId},
    );

    const title = te('editRole');

    if (response.isSuccess) {
        yield* put(adminAction.getRoles(opt({action: 'refresh'})));
        yield* put(showSuccess(title, te('roleEdited')));
        yield* put(adminAction.setEditedRoleId(null));
        yield* put(formHelpers.reset(roleFormName));
    } else {
        yield putAll(showBeError(response, title));
        yield* put(formHelpers.stopSubmit(roleFormName, extractFormErrorsFromResponse(response)));
    }
}

/** Runs the admin saga that updates the selected role. */
export function* updateRoleSaga(): SagaIterator {
    yield takeLatestF('admin/UPDATE_ROLE', execute);
}
